import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/prepaidLoyalty/servicesTabStyle';
import { SinglePackage } from 'utils/api/models/numbers/singlePackage';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { HeadingS, BodySBold } from 'components/Typography/Typography';
// import CustomTooltip from 'components/CustomTooltip/CustomTooltip';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import SingleItem from './subcomponents/SingleItem';
import VatClauseWrapper from './subcomponents/VatClauseWrapper';
import { translate } from 'components/Translation';
import { ISelectedPackage } from 'views/PrepaidLoyalty/AddNewServices';

// @ts-ignore
const useStyles = makeStyles(styles);

type ISubExpansionPanelProps = {
	packages: SinglePackage[];
	collapsedSub: string;
	handleSelected: (singlePackage: ISelectedPackage) => void;
	handleCollapsedSub: (name: string) => void;
	packageIdentifier: types.ecommerce.PackageType;
	selectedPackages: ISelectedPackage[];
};

const SubExpansionPanel = ({
	collapsedSub,
	handleSelected,
	handleCollapsedSub,
	packages,
	packageIdentifier,
	selectedPackages,
}: ISubExpansionPanelProps) => {
	const classes = useStyles();

	const isCollapsed = useMemo(() => collapsedSub === packageIdentifier, [collapsedSub, packageIdentifier]);

	const packagesUniqueIds = useMemo(() => packages.map(({ uniqueID }) => uniqueID), [packages]);

	const selectedPackage: ISelectedPackage | undefined = useMemo(
		() => selectedPackages.find(({ data }) => packagesUniqueIds.indexOf(data.uniqueID) >= 0),
		[selectedPackages, packagesUniqueIds]
	);

	return (
		<ExpansionPanel
			expanded={isCollapsed}
			onChange={() => handleCollapsedSub(packageIdentifier)}
			classes={{
				root: classes.expansionPanel,
				expanded: classes.expansionPanelExpanded,
			}}
		>
			<ExpansionPanelSummary
				expandIcon={<ExpandMore />}
				classes={{
					root: classes.expansionSubpanelSummary,
					expanded: classes.expansionPanelSummaryExpanded,
					content: classes.expansionPanelSummaryContent,
					expandIcon: classes.expansionPanelSummaryExpandIcon,
				}}
			>
				<div className={classes.packageName}>
					<HeadingS disableMargin>
						{translate(`prepaid.loyalty.add.new.services.${packageIdentifier}`)}
					</HeadingS>
				</div>
				{/*<div className={'package-tooltip'}>*/}
				{/*	<CustomTooltip placement="bottom">*/}
				{/*		{translate(`prepaid.loyalty.add.new.services.${packageIdentifier}`)}*/}
				{/*	</CustomTooltip>*/}
				{/*</div>*/}
				<ConditionalRender
					show={!isCollapsed && !!selectedPackage}
					onTrue={() => (
						<div className={classes.selectedPackContainer}>
							<div className={classes.badge}></div>
							<div className={classes.selectedPackDescription}>
								<BodySBold disableMargin inline color="enterprise">
									{selectedPackage?.data.shortDescription}
								</BodySBold>
							</div>
						</div>
					)}
				/>
			</ExpansionPanelSummary>
			<ExpansionPanelDetails className={classes.expansionPanelDetails}>
				<div className={classes.expansionPanelSubItems}>
					{packages.map((item: SinglePackage) => (
						<SingleItem
							key={item.uniqueID}
							isSelected={selectedPackage?.data.uniqueID === item.uniqueID}
							priceOffer={item.priceOffer}
							shortDescription={item.shortDescription}
							name={item.name}
							handleSelected={() =>
								handleSelected({
									data: item,
									type: packageIdentifier,
								})
							}
						/>
					))}
					<VatClauseWrapper />
				</div>
			</ExpansionPanelDetails>
		</ExpansionPanel>
	);
};
export default SubExpansionPanel;
